import { asOrderTicketId, OrderTicketId } from "@goodfill/domain-properties";
import {
  MultiselectCriteria,
  multiselectFilter,
  MultiselectFilterChangeFunction,
  MultiselectColumnDefinition,
} from "../generic/MultiselectColumnDefinition";

export const ORDER_TICKET_ID_CRITERIA_KEY = "orderTicketId";

export function getSortedOrderTicketIds<TItemKey extends string>(
  key: TItemKey,
  rows: Array<{
    [key in TItemKey]: OrderTicketId;
  }>,
) {
  const values = Array.from(new Set(rows.map((row) => row[key])).values());
  values.sort();

  return values;
}

export const orderTicketIdFilter = <TItemKey extends string>(key: TItemKey) =>
  multiselectFilter(ORDER_TICKET_ID_CRITERIA_KEY, key);

export const OrderTicketIdColumnDefinition = <TItemKey extends string>(
  itemKey: TItemKey,
  criteria: MultiselectCriteria<typeof ORDER_TICKET_ID_CRITERIA_KEY, OrderTicketId>,
  onFilterChange: MultiselectFilterChangeFunction<typeof ORDER_TICKET_ID_CRITERIA_KEY, OrderTicketId>,
  orderTicketIds: OrderTicketId[],
) =>
  MultiselectColumnDefinition(
    "Goodfill Order No.",
    itemKey,
    ORDER_TICKET_ID_CRITERIA_KEY,
    criteria,
    onFilterChange,
    orderTicketIds,
    (a: OrderTicketId) => `${a}`,
    (a: string) => asOrderTicketId(a),
    300,
  );
